import { InstrumentShell } from "../components/InstrumentShell";
import { SoundDnaPanel } from "../components/SoundDnaPanel";
import { TransportBar } from "../components/TransportBar";
import type { InstrumentLayoutProps } from "./layoutTypes";

export function DesktopInstrumentLayout(props: InstrumentLayoutProps) {
  return (
    <div className="play-layout desktop-instrument-layout" data-testid="desktop-instrument-layout">
      <div className="play-main">
        <InstrumentShell
          instrument={props.instrument}
          variant={props.variant}
          tuning={props.tuning}
          activeNotes={props.activeNotes}
          onNoteStart={props.onNoteStart}
          onNoteEnd={props.onNoteEnd}
          onControl={props.onControl}
        />
        {props.audioError ? (
          <p className="status-message error-badge" role="alert">
            {props.audioError}
          </p>
        ) : null}
      </div>
      <div className="desktop-sound-panel">
        <SoundDnaPanel instrument={props.instrument} />
      </div>
      <TransportBar
        instrument={props.instrument}
        pressedKeys={props.pressedKeys}
        onOrnament={props.onOrnament}
        onControl={props.onControl}
      />
    </div>
  );
}
